import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Paper,
  SecondarySpanMedium,  
  TerciarySpanLarge, 
  PrimarySpanMedium
} from 'atoms/StyledComponents'
import { Button } from 'react-bootstrap';


const useRowStyles = makeStyles({
  provider_name_hover:{
    "&:hover": {
      textDecoration: "underline",
      cursor: "Pointer"
    }
  },
  clickable: {
    color: "#1A0DAB",
    fontWeight: "bold"
  }
});


export default function ProviderSearchResultCard(props) {
    const { row } = props;

    const classes = useRowStyles();
  
    return (
        <Paper style={{ display: "flex", width: "100%", paddingLeft: "20px", paddingRight: "20px", paddingTop: "25px", paddingBottom: "25px" }}>
          {/* left */}
          <div style={{ float: "left", width: "33%" }}>

            {/* top left */}
            <span>
              <PrimarySpanMedium 
                className={classes.provider_name_hover}
                onClick={props.on_click_provider}
              >
                {props.provider_name}
              </PrimarySpanMedium>
              <span style={{ display: "table" }}>
                <TerciarySpanLarge>
                  {props.location} 
                </TerciarySpanLarge>
              </span>
            </span>

          </div>

          {/* middle */}
          <div style={{ float: "left", marginLeft: '38px', width: "33%", height: "100%"}}>
            {/* top */}
            <div style={{ marginBottom: "14px"}}>
              <SecondarySpanMedium style={{ marginRight: "6px", fontWeight: 700 }}>{props.fees_accounted_for}</SecondarySpanMedium>
            </div> 

          </div>

          {/* right */}
          <div style={{ float: "right", width: "33%", textAlign: "right" }}>
            <Button
              onClick={props.on_click_provider}
              variant="primary"
              className="light"
            >
              More Info
            </Button>
          </div>

        </Paper>
    );
  }
  